export const DEFAULT_BUTTON_COLOR = '#2681DB';
export const DEFAULT_BUTTON_TEXT_COLOR = '#fff';
export const DEFAULT_LINK_TEXT_COLOR = '#2681DB';
export const DEFAULT_BACKGROUND_COLOR = '#fff';
export const DEFAULT_MESSAGE_TEXT_COLOR = '#465C6F';
export const DEFAULT_CTA_POSITION = 'bottom-left';
export const DEFAULT_FORM_CTA_PLACEHOLDER_TEXT = 'e.g. Submit your email address here';
